import React, { FC } from 'react';

import { Box } from '@mui/material';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

type MarkdownVariablesType = Record<string, string>;

type Props = {
  markdown: string;
  variables?: MarkdownVariablesType;
};

const renderMarkdownWithVariables = (
  markdown: string,
  variables: MarkdownVariablesType = {},
): string =>
  markdown.replace(/\{\{([A-Z0-9_]+)\}\}/g, (placeholder, variableName) => {
    return variables[variableName] ?? placeholder;
  });

const LegalPage: FC<Props> = ({ markdown, variables }) => {
  const renderedMarkdown = renderMarkdownWithVariables(markdown, variables);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        color: 'text.primary',
        py: { xs: 4, md: 6 },
        px: { xs: 2, md: 3 },
      }}
    >
      <Box
        sx={{
          maxWidth: 920,
          mx: 'auto',
          '& h1, & h2, & h3': { color: 'text.primary' },
          '& p, & li': { color: 'text.secondary', lineHeight: 1.7 },
          '& a': { color: 'primary.main' },
          '& hr': { borderColor: 'divider' },
        }}
      >
        <Markdown remarkPlugins={[remarkGfm]}>{renderedMarkdown}</Markdown>
      </Box>
    </Box>
  );
};

export default LegalPage;
